module.exports = __webpack_public_path__ + "static/index/img/baikal-109.bd0b7107.jpg";